/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /*
   * "Image carousel" section (sections/section-image-carousel.liquid)
   * Native horizontal scroll + scroll-snap, driven by our own arrows/dots
   * (kept independent from Flickity to avoid it fighting with our markup).
   */
  var imageCarouselSelector = '[data-section-type="image-carousel"]';
  var imageCarouselInstances = new Map();

  function ImageCarousel(container) {
    this.container = container;
    this.slider = container.querySelector('[data-image-carousel-slider]');

    if (!this.slider) return;

    this.items = Array.prototype.slice.call(this.slider.querySelectorAll('[data-image-carousel-item]'));
    this.prevButton = container.querySelector('[data-image-carousel-prev]');
    this.nextButton = container.querySelector('[data-image-carousel-next]');
    this.dots = Array.prototype.slice.call(container.querySelectorAll('[data-image-carousel-dot]'));
    this.autoplay = this.slider.getAttribute('data-autoplay') === 'true';
    this.autoplaySpeed = parseInt(this.slider.getAttribute('data-autoplay-speed'), 10) || 5000;
    this.currentIndex = 0;
    this.autoplayTimer = null;
    this.scrollTimeout = null;

    if (!this.items.length) return;

    this.onPrevClick = this.onPrevClick.bind(this);
    this.onNextClick = this.onNextClick.bind(this);
    this.onDotClick = this.onDotClick.bind(this);
    this.onScroll = this.onScroll.bind(this);

    if (this.prevButton) this.prevButton.addEventListener('click', this.onPrevClick);
    if (this.nextButton) this.nextButton.addEventListener('click', this.onNextClick);
    this.dots.forEach(function(dot) {
      dot.addEventListener('click', this.onDotClick);
    }.bind(this));

    this.slider.addEventListener('scroll', this.onScroll, {passive: true});

    if (this.autoplay && this.items.length > 1) this.startAutoplay();
  }

  ImageCarousel.prototype.scrollToIndex = function(index) {
    var max = this.items.length - 1;
    if (index < 0) index = max;
    if (index > max) index = 0;

    this.currentIndex = index;
    var item = this.items[index];
    var left = item.offsetLeft - this.slider.offsetLeft;
    this.slider.scrollTo({left: left, behavior: 'smooth'});
    this.updateDots(index);
  };

  ImageCarousel.prototype.onPrevClick = function() {
    this.stopAutoplay();
    this.scrollToIndex(this.currentIndex - 1);
  };

  ImageCarousel.prototype.onNextClick = function() {
    this.stopAutoplay();
    this.scrollToIndex(this.currentIndex + 1);
  };

  ImageCarousel.prototype.onDotClick = function(event) {
    this.stopAutoplay();
    var index = parseInt(event.currentTarget.getAttribute('data-index'), 10);
    this.scrollToIndex(index);
  };

  ImageCarousel.prototype.onScroll = function() {
    var self = this;
    clearTimeout(this.scrollTimeout);
    this.scrollTimeout = setTimeout(function() {
      self.syncIndexFromScroll();
    }, 100);
  };

  ImageCarousel.prototype.syncIndexFromScroll = function() {
    var sliderLeft = this.slider.getBoundingClientRect().left;
    var closest = 0;
    var closestDistance = Infinity;

    this.items.forEach(function(item, i) {
      var distance = Math.abs(item.getBoundingClientRect().left - sliderLeft);
      if (distance < closestDistance) {
        closestDistance = distance;
        closest = i;
      }
    });

    this.currentIndex = closest;
    this.updateDots(closest);
  };

  ImageCarousel.prototype.updateDots = function(index) {
    this.dots.forEach(function(dot, i) {
      dot.classList.toggle('is-selected', i === index);
    });
  };

  ImageCarousel.prototype.startAutoplay = function() {
    var self = this;
    this.stopAutoplay();
    this.autoplayTimer = setInterval(function() {
      self.scrollToIndex(self.currentIndex + 1);
    }, this.autoplaySpeed);
  };

  ImageCarousel.prototype.stopAutoplay = function() {
    if (this.autoplayTimer) clearInterval(this.autoplayTimer);
    this.autoplayTimer = null;
  };

  ImageCarousel.prototype.selectBlockById = function(blockId) {
    var index = this.items.findIndex(function(item) {
      return item.getAttribute('data-block-id') === blockId;
    });
    if (index > -1) this.scrollToIndex(index);
  };

  ImageCarousel.prototype.onUnload = function() {
    this.stopAutoplay();
    if (this.slider) this.slider.removeEventListener('scroll', this.onScroll);
  };


  function initImageCarousels(scope) {
    var root = scope || document;
    var containers = root.matches && root.matches(imageCarouselSelector) ? [root] : root.querySelectorAll(imageCarouselSelector);

    containers.forEach(function(container) {
      if (imageCarouselInstances.has(container)) return;
      imageCarouselInstances.set(container, new ImageCarousel(container));
    });
  }

  function destroyImageCarousels(scope) {
    var root = scope || document;
    var containers = root.matches && root.matches(imageCarouselSelector) ? [root] : root.querySelectorAll(imageCarouselSelector);

    containers.forEach(function(container) {
      var instance = imageCarouselInstances.get(container);
      if (instance) {
        instance.onUnload();
        imageCarouselInstances.delete(container);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initImageCarousels();
    });
  } else {
    initImageCarousels();
  }

  document.addEventListener('shopify:section:load', function(event) {
    initImageCarousels(event.target);
  });

  document.addEventListener('shopify:section:unload', function(event) {
    destroyImageCarousels(event.target);
  });

  document.addEventListener('shopify:block:select', function(event) {
    var container = event.target.closest ? event.target.closest(imageCarouselSelector) : null;
    if (!container) return;
    var instance = imageCarouselInstances.get(container);
    if (instance) instance.selectBlockById(event.target.getAttribute('data-block-id'));
  });

  /*
   * "Blog" section (sections/blog.liquid)
   * Optional dropdown toggle for the tag filters list, enabled/disabled
   * separately for desktop/mobile via section settings. The open/closed
   * default state is handled purely by CSS (see template-blog.css); this
   * script only flips the override class and keeps aria-expanded in sync.
   */
  var blogTagsSelector = '[data-blog-tags]';
  var blogTagsDesktopBreakpoint = 1024;
  var blogTagsInstances = new Map();

  function BlogTagsDropdown(container) {
    this.container = container;
    this.trigger = container.querySelector('[data-blog-tags-trigger]');
    this.list = container.querySelector('[data-blog-tags-list]');

    if (!this.trigger || !this.list) return;

    this.desktopEnabled = container.getAttribute('data-dropdown-desktop') === 'true';
    this.mobileEnabled = container.getAttribute('data-dropdown-mobile') === 'true';

    this.onTriggerClick = this.onTriggerClick.bind(this);
    this.onResize = this.onResize.bind(this);

    this.trigger.addEventListener('click', this.onTriggerClick);
    window.addEventListener('resize', this.onResize);

    this.syncAriaExpanded();
  }

  BlogTagsDropdown.prototype.isDesktop = function() {
    return window.innerWidth >= blogTagsDesktopBreakpoint;
  };

  BlogTagsDropdown.prototype.isExpanded = function() {
    if (this.isDesktop()) {
      return this.desktopEnabled ? !this.container.classList.contains('blog__tags--collapsed') : true;
    }
    return this.mobileEnabled ? this.container.classList.contains('blog__tags--expanded') : true;
  };

  BlogTagsDropdown.prototype.syncAriaExpanded = function() {
    this.trigger.setAttribute('aria-expanded', String(this.isExpanded()));
  };

  BlogTagsDropdown.prototype.onTriggerClick = function() {
    if (this.isDesktop()) {
      if (!this.desktopEnabled) return;
      this.container.classList.toggle('blog__tags--collapsed');
    } else {
      if (!this.mobileEnabled) return;
      this.container.classList.toggle('blog__tags--expanded');
    }
    this.syncAriaExpanded();
  };

  BlogTagsDropdown.prototype.onResize = function() {
    this.syncAriaExpanded();
  };

  BlogTagsDropdown.prototype.onUnload = function() {
    this.trigger.removeEventListener('click', this.onTriggerClick);
    window.removeEventListener('resize', this.onResize);
  };

  function initBlogTagsDropdowns(scope) {
    var root = scope || document;
    var containers = root.matches && root.matches(blogTagsSelector) ? [root] : root.querySelectorAll(blogTagsSelector);

    containers.forEach(function(container) {
      if (blogTagsInstances.has(container)) return;
      blogTagsInstances.set(container, new BlogTagsDropdown(container));
    });
  }

  function destroyBlogTagsDropdowns(scope) {
    var root = scope || document;
    var containers = root.matches && root.matches(blogTagsSelector) ? [root] : root.querySelectorAll(blogTagsSelector);

    containers.forEach(function(container) {
      var instance = blogTagsInstances.get(container);
      if (instance) {
        instance.onUnload();
        blogTagsInstances.delete(container);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initBlogTagsDropdowns();
    });
  } else {
    initBlogTagsDropdowns();
  }

  document.addEventListener('shopify:section:load', function(event) {
    initBlogTagsDropdowns(event.target);
  });

  document.addEventListener('shopify:section:unload', function(event) {
    destroyBlogTagsDropdowns(event.target);
  });




  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
